import { render, staticRenderFns } from "./AttendGroupInventory.vue?vue&type=template&id=d881740c&lang=pug&"
import script from "./AttendGroupInventory.vue?vue&type=script&lang=js&"
export * from "./AttendGroupInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports